











































































































































































































import { Component, Mixins, Emit, Prop } from "vue-property-decorator";
import {
  OfficeSearchCondition,
  DefaultOfficeSearchCondition,
  OfficeItem,
  DefaultOfficeItem,
  PatientItem,
  DefaultPatientItem,
} from "@/components/ai/types";
import ExperimentPatientInfoViewer from "@/components/ai/ExperimentPatientInfoViewer.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";

@Component({
  components: {
    ExperimentPatientInfoViewer,
  },
})
/** お試し利用者選択 */
export default class ExperimentPatientSelector extends Mixins(
  AxiosMixin,
  UtilMixin
) {
  /** Prop */

  /** 利用画面 1:計画書 2:報告書 */
  @Prop({ default: 1 }) private viewType!: number;

  /** 変数 */

  /** ダイアログ制御 */
  private dialog = false;

  /** 表示モード 1:事業所選択 2:利用者選択 */
  private mode = 1;

  /** フィルター用キーワード */
  private searchKeyword = "";

  /** 1ページあたりの表示件数 */
  private itemPerPage = 25;

  /** 表の現在のページ数 */
  private pageNo = 1;

  /** 事業所検索条件 */
  private officeSearchCondition: OfficeSearchCondition = {
    ...DefaultOfficeSearchCondition(),
  };

  /** 事業所一覧データ */
  private officeItems: OfficeItem[] = [];

  /** 選択事業所データ */
  private officeItem: OfficeItem = DefaultOfficeItem();

  /** 事業所データテーブル用ヘッダー */
  private officeHeaders = [
    {
      text: "",
      value: "actions",
      width: "80px",
      sortable: false,
    },
    {
      text: "企業コード",
      value: "co_code",
      width: "140px",
      filterable: true,
      sortable: true,
    },
    {
      text: "法人名",
      value: "co_name",
      width: "180px",
      filterable: true,
      sortable: true,
    },
    {
      text: "事業所コード",
      value: "kst_no",
      width: "150px",
      filterable: true,
      sortable: true,
    },
    {
      text: "主たる事業所",
      value: "office_div",
      width: "150px",
      filterable: false,
      sortable: true,
    },
    {
      text: "事業所名",
      value: "office_name",
      width: "180px",
      filterable: true,
      sortable: true,
    },
  ];

  /** 利用者一覧データ */
  private patientItems: PatientItem[] = [];

  /** 選択(詳細)利用者データ */
  private patientItem: PatientItem = DefaultPatientItem();

  /** 利用者データテーブル用ヘッダー */
  private patientHeaders = [
    {
      text: "",
      value: "actions",
      width: "200px",
      sortable: false,
    },
    {
      text: "氏名",
      value: "patient_name",
      width: "180px",
      filterable: true,
      sortable: true,
    },
    {
      text: "ふりがな",
      value: "patient_name_kana",
      width: "180px",
      filterable: true,
      sortable: true,
    },
    {
      text: "性別",
      value: "patient_sex",
      width: "100px",
      filterable: true,
      sortable: true,
    },
    {
      text: "年齢",
      value: "patient_age",
      width: "100px",
      filterable: true,
      sortable: true,
    },
  ];

  /** 詳細取得年月 */
  private yearmonth = "";

  /** ダイアログタイトル */
  private get Title(): string {
    return this.mode == 1 ? "事業所選択" : "利用者選択";
  }

  /** 関数 */

  created() {
    this.yearmonth = this.getCurrentYearmonth();
  }

  /** 事業所検索 */
  private async searchOffice() {
    if (
      this.officeSearchCondition.co_code == "" &&
      this.officeSearchCondition.co_name == "" &&
      this.officeSearchCondition.kst_no == "" &&
      this.officeSearchCondition.office_name == ""
    ) {
      await this.$openAlert("検索条件を入力してください。");
      return;
    }

    this.postJsonCheck(
      window.base_url +
        (this.viewType == 1
          ? "/api/admin/aivnplan/offices/get"
          : "/api/admin/aimonthreport/offices/get"),
      this.officeSearchCondition,
      (res) => {
        this.officeItems = res.data.items;
        this.pageNo = 1;
      }
    );
  }

  /** 事業所選択 */
  private changeOffice(item: OfficeItem) {
    // 選択事業所に所属する利用者を一覧取得して利用者選択モードへ移行
    this.postJsonCheck(
      window.base_url +
        (this.viewType == 1
          ? "/api/admin/aivnplan/patients/get"
          : "/api/admin/aimonthreport/patients/get"),
      { agreement_id: item.agreement_id, office_id: item.office_id },
      (res) => {
        this.patientItems = res.data.patients;
        this.officeItem = { ...item };
        // 表示モード変更
        this.mode = 2;
        // リセット
        this.pageNo = 1;
        this.searchKeyword = "";
        this.officeSearchCondition = { ...DefaultOfficeSearchCondition() };
        this.patientItem = { ...DefaultPatientItem() };
        // スクロール
        document.getElementById("top")?.scrollIntoView({
          behavior: "auto",
          block: "start",
        });
      }
    );
  }

  /** 事業所を選択し直す */
  private backToOfficeList() {
    // 表示モード変更
    this.mode = 1;
    // リセット
    this.pageNo = 1;
    this.searchKeyword = "";
    this.officeItem = { ...DefaultOfficeItem() };
    this.yearmonth = this.getCurrentYearmonth();
    // スクロール
    document.getElementById("top")?.scrollIntoView({
      behavior: "auto",
      block: "start",
    });
  }

  /** 利用者詳細情報を取得 */
  private async fetchPatientInfo(
    agreementId: number,
    patientId: number,
    yearmonth: string
  ) {
    this.postJsonCheck(
      window.base_url +
        (this.viewType == 1
          ? "/api/admin/aivnplan/patient/detail/get"
          : "/api/admin/aimonthreport/patient/detail/get"),
      {
        view_type: this.viewType,
        agreement_id: agreementId,
        patient_id: patientId,
        yearmonth: yearmonth,
      },
      (res) => {
        this.patientItem = res.data.patient_item;
      }
    );
  }

  /** 詳細表示を閉じる */
  private showDown() {
    this.patientItem = { ...DefaultPatientItem() };
  }

  /** 当月取得 */
  private getCurrentYearmonth() {
    return this.dateToStr(new Date(), "yyyy-MM");
  }

  /** 表のページ変更 */
  private changePage(pageNo: number) {
    this.pageNo = pageNo;
  }

  /** 詳細表示中の行を目立たせる */
  private opendItemRowBackground(item: PatientItem) {
    return item.patient_id == this.patientItem.patient_id
      ? "ibow-admin-selected-item-row"
      : "";
  }

  /** ダイアログ開く */
  public open() {
    this.dialog = true;
  }

  /** ダイアログ閉じる */
  public close() {
    this.dialog = false;
  }

  /** Emit */

  /** 利用者選択 */
  @Emit("change:patient")
  private changePatient(item: PatientItem) {
    return {
      officeItem: this.officeItem,
      patientItem: item,
      yearmonth: this.viewType == 1 ? "" : this.yearmonth,
    };
  }
}
